import React, { useMemo } from 'react';

import { GameCategory } from 'js/app/components/main/Games/components/GameCategory';

import { DYNAMIC_CATEGORIES } from 'js/app/components/main/Games/constants';
import { useFilterDynamicCategory } from 'js/app/components/main/Games/hooks/useFilterDynamicCategory';
import { useGamesSelector } from 'js/app/components/main/Games/store/context';

export const AllCategory = () => {
    const { categories } = useGamesSelector();
    const filterCategories = useFilterDynamicCategory();
    const filteredCategories = useMemo(() => {
        return categories
            .filter(category => category.name !== DYNAMIC_CATEGORIES.ALL_CATEGORY && filterCategories(category));
    }, [categories, filterCategories]);

    return (
        <>
            {filteredCategories.map(category => (
                <React.Fragment key={category.name}>
                    <GameCategory category={category} />
                </React.Fragment>
            ))}
        </>
    );
};
